export const interpolateByRange = (
  minimum: number,
  input: number,
  maximum: number
) => Math.max(minimum, Math.min(input, maximum));
